import { SVGProps, Ref, forwardRef } from 'react';

export const FolderHeartOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 6.048v-.381C1 2.167 2.167 1 5.667 1h2L8.2 2.333h2.133c3.153 0 4.412.947 4.631 3.693.655.393.981 1.028 1.03 1.974H14.59c-.026-.355-.107-.537-.176-.627-.116-.153-.54-.473-2.211-.473H3.796c-1.671 0-2.095.32-2.21.473-.146.19-.342.779.02 2.534.348 1.69.768 2.525 1.26 2.978.45.417 1.188.715 2.734.715h2.9V15H5.6C2.204 15 .96 13.707.235 10.19-.22 7.98-.04 6.697 1 6.048m12.501-.474c-.113-.675-.309-1.027-.512-1.23-.314-.314-.983-.61-2.656-.61h-3.08L6.718 2.4H5.667c-1.673 0-2.342.297-2.656.61-.31.31-.602.963-.61 2.578A10 10 0 0 1 3.795 5.5h8.408q.723 0 1.297.074"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.303 9.557c-.628-.514-1.386-.681-2.082-.505-.915.231-1.62 1.04-1.62 2.12 0 .955.657 1.7 1.279 2.228.605.512 1.35.959 1.942 1.313l.479.287.478-.287c.592-.354 1.337-.8 1.942-1.313.622-.527 1.279-1.273 1.279-2.228 0-1.054-.716-1.85-1.61-2.09-.692-.185-1.454-.036-2.088.475m-1.74.852c-.312.08-.562.344-.562.764 0 .295.219.68.784 1.159.44.373.983.713 1.516 1.035.533-.322 1.075-.662 1.515-1.036.566-.478.784-.863.784-1.158a.75.75 0 0 0-.572-.738c-.307-.082-.764-.01-1.154.548l-.573.818-.574-.818c-.398-.568-.863-.65-1.164-.574"
                fill="currentColor"
            />
        </g>
    </svg>
));
FolderHeartOutlinedSize16Glyph.displayName = 'FolderHeartOutlinedSize16Glyph';
